<template>
	<div>
	    <div class="utils__title mb-3">
	      <strong class="text-uppercase font-size-16">{{ $t('post.title') }}</strong>
	      <div class="right">
	      	<router-link :to="`/post/new`">
	      		<a-button type="primary">{{ $t('post.new') }}</a-button>
	      	</router-link>
	      </div>
	    </div>
	    <div class="row">
	      <div class="col-lg-12">
	        <div class="card">
	          <div class="card-body">
				  <a-table
				    :columns="columns"
				    :rowKey="record => record.id"
				    :dataSource="data"
				    :loading="loading"
				  >
				    <template slot="stt" slot-scope="id, record, index">
				      {{ index+1 }}
				    </template>
				    <template slot="name" slot-scope="title, record">
				      <router-link :to="`/post/edit/${record.id}`">{{ title }}</router-link>
				    </template>
				    <template slot="created" slot-scope="created">
				    	{{ created | formatDate }}
				    </template>
				  </a-table>
				</div>
			</div>
		  </div>
		</div>
	</div>
</template>
<script>
import api from '@/mixins/api'
import helper from '@/mixins/helper'
export default {
	data() {
		const columns = [
		    {
		      title: '#',
		      width: '30px',
		      dataIndex: 'id',
		      scopedSlots: { customRender: 'stt' },
		    },
		    {
		      title: 'Name',
		      dataIndex: 'title',
		      scopedSlots: { customRender: 'name' },
		    },
		    {
		      title: 'Time',
		      dataIndex: 'created',
		      width: '20%',
		      scopedSlots: { customRender: 'created' },
		    },
		    {
		      title: 'Category',
		      dataIndex: 'category',
		      width: '10%'
		    },
		  ];
		return {
			columns,
			data: [],
			loading: false
		}
	},
	methods: {
		loadData() {
			this.loading = true
			this.api('news/list').then(res => {
				this.data = res
			}).finally(e => {
				this.loading = false
			})
		}
	},
	mounted() {
		this.loadData()
	},
	mixins: [api, helper]
}
</script>
<style scoped>
.right {
	float: right;
}
a{
	color: #FF5254;
}
a:hover{
	color: #08f !important;
}
</style>